import PropTypes from 'prop-types';
import React from 'react';

import { Expandable } from 'sharedComponents';
import { getAssetIcon } from 'helpers/icons';
import KPIListComponent from './KPIListComponent';


const AssetItemComponent = ({
    asset,
    selectedAsset,
    selectedAssetCapability,
    capabilityLoadingStatus,
    onAssetClick,
    selectedKPIType,
    getKPIsForKPIType,
    getTrendKPIsForAssetV2,
    chartData,
    setKpi,
    kpiCount,
    crossAssetAnalysisActiveTab
}) => {


    const handleAssetToggle = () => {
        if (selectedAsset?.id !== asset?.id) {
            onAssetClick(asset?.id);
        } else {
            console.log('assetId clicked from cross asset analysis assset id is not mathing', asset?.id);
        }
    };

    return <Expandable
        title={
            <div className='asset-list-item'>
                <div className='asset-icon-container'>{getAssetIcon(asset?.assetType, { width: 20, height: 20 })}</div>
                <div className='asset-list-item-name'>{asset?.name}</div>
            </div>
        }
        onClick={handleAssetToggle}
        open={selectedAsset?.id === asset?.id}
        kpiCount={kpiCount}
    >
        <KPIListComponent
            selectedAsset={selectedAsset}
            selectedAssetCapability={selectedAssetCapability}
            capabilityLoadingStatus={capabilityLoadingStatus}
            getKPIsForKPIType={getKPIsForKPIType}
            getTrendKPIsForAssetV2={getTrendKPIsForAssetV2}
            selectedKPIType={selectedKPIType}
            setKpi={setKpi}
            chartData={chartData}
            crossAssetAnalysisActiveTab={crossAssetAnalysisActiveTab}
        />
    </Expandable>;
};

AssetItemComponent.propTypes = {
    asset: PropTypes.any,
    selectedAsset: PropTypes.any,
    selectedAssetCapability: PropTypes.any,
    selectedKPIType: PropTypes.any,
    kpis: PropTypes.any,
    kpiLoadingStatus: PropTypes.any,
    setSelectedAsset: PropTypes.func,
    getKPIsForKPIType: PropTypes.func,
    getTrendKPIsForAssetV2: PropTypes.func,
    kpiCount: PropTypes.number,
    capabilityLoadingStatus: PropTypes.string,
    setKpi: PropTypes.func,
    onAssetClick: PropTypes.func,
    crossAssetAnalysisActiveTab: PropTypes.string
};

export default AssetItemComponent;
